import { Component, OnInit, Injector } from '@angular/core';

import { BitfFormItemComponent } from '../form-item/bitf-form-item.component';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';

/**
 * Installation
 * - https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/angular.html
 * - In sharedModule: import CKEditorModule
 */
@Component({
  selector: 'bitf-ck-form-item',
  templateUrl: './bitf-ck-form-item.component.html',
  styleUrls: ['./bitf-ck-form-item.component.scss'],
})
export class BitfCkFormItemComponent extends BitfFormItemComponent implements OnInit {
  editor = ClassicEditor;
  editorConfig = {
    toolbar: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', '|', 'link', 'unlink'],
    placeholder: '',
  };

  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.formItem.metaData && this.formItem.metaData.editorConfig) {
      Object.assign(this.editorConfig, this.formItem.metaData.editorConfig);
    }
    this.editorConfig.placeholder = this.formItem.label || '';
  }
}
